import React, { useEffect } from 'react';
import './ShopSummary.css';



const ShopSummary = (props) => {

  // Destructuring props to extract cart data and callback function
  const { cart, onSummaryChange } = props;

  // Calculate the subtotal by summing up the price * quantity for all items in the cart
  const subTotal = cart.reduce((total, item) => total + (item.price * item.quantity), 0);

  // Define base delivery fee
  const baseDeliveryFee = 5;
  let deliveryFee = baseDeliveryFee;

  // Apply free delivery for orders above $300
  if (subTotal >= 300) {
      deliveryFee = 0;
  }

  // Calculate total discounted amount by subtracting discounted price from actual price for each item
  const discountedAmount = cart.reduce((total, item) => total + ((item.price - item.disprice) * item.quantity), 0);

  // Define tax rate (10%) and calculate tax amount
  const taxRate = 0.1;
  const taxAmount = subTotal * taxRate;

  // Calculate final cart total after including tax, delivery fee, and deducting discounts
  const cartTotal = subTotal + taxAmount + deliveryFee - discountedAmount;

  // Pass the calculated summary values to the parent component whenever they change
  useEffect(() => {
    if (onSummaryChange) {
      onSummaryChange({
        subTotal,
        deliveryFee,
        discountedAmount,
        taxAmount,
        cartTotal,
      });
    }
  }, [subTotal, deliveryFee, discountedAmount, taxAmount, cartTotal, onSummaryChange]);

  return (
    <div className='shop-summary'>

      {/* Display the sub total amount */}
      <div className='summary-item'>
        <div className='box name'>Sub Total</div>
        <div className='box value'>${subTotal.toFixed(2)}</div> {/* Ensure two decimal places */}
      </div>

      {/* Display the delivery fee */}
      <div className='summary-item'>
        <div className='box name'>Delivery Fee</div>
        <div className='box value'>${deliveryFee.toFixed(2)}</div>
      </div>

      {/* Display the total discount applied */}
      <div className='summary-item'>
        <div className='box name'>Discount</div>
        <div className='box value'>${discountedAmount.toFixed(2)}</div>
      </div>

      {/* Display the tax amount applied */}
      <div className='summary-item'>
        <div className='box name'>Tax</div>
        <div className='box value'>${taxAmount.toFixed(2)}</div>
      </div>

      {/* Display the final total cost after all calculations */}
      <div className='summary-item'>
        <div className='box name'>Total</div>
        <div className='box value'>${cartTotal.toFixed(2)}</div>
      </div>

    </div>
  );
};

export default ShopSummary;